import { Injectable } from '@angular/core';
import { AccessRightType, ApplicationSettingsType, ObjectTypes, SideListOptionType } from '@fi-shared/types';
import { ITabItem } from '@fi-app/utilities/tabs/tabs';
import { AccessToApplicationTypeService } from '@fi-shared/fi-shared-services/access-to-application-type.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { AppTextService } from '@fi-shared/app-text';
import { getObjectTypeNameTextId } from '@fi-shared/utils';

@Injectable()
export class ChecklistV2StatesService {
    constructor(
        private stateAccessCheckService: StateAccessCheckService,
        private accessToApplicationTypeService: AccessToApplicationTypeService,
        private appTextService: AppTextService,
    ) {}

    getChecklistV2SettingsTabs() {
        const tabs: ITabItem[] = [];
        const adminRight = this.accessToApplicationTypeService.HasAccessToApplicationType(
            ApplicationSettingsType.ChecklistV2Local,
            AccessRightType.Admin,
        );
        const shareRight = this.accessToApplicationTypeService.HasAccessToApplicationType(
            ApplicationSettingsType.ChecklistV2Local,
            AccessRightType.Share,
        );

        if (this.stateAccessCheckService.isStateAllowedForCurrentUser(FiStateNames.ChecklistV2.List)) {
            const textId = getObjectTypeNameTextId(ObjectTypes.Checklist2, true);
            tabs.push({
                Title: this.appTextService.get(textId),
                Sref: FiStateNames.ChecklistV2.List,
                SrefParams: { filterType: SideListOptionType.CurrentCheckLists },
                AddState: adminRight ? FiStateNames.ChecklistV2.Add._name : null,
            });
        }

        if (this.stateAccessCheckService.isStateAllowedForCurrentUser(FiStateNames.ChecklistV2.Template.List)) {
            const textId = getObjectTypeNameTextId(ObjectTypes.Checklist2Template, true);
            tabs.push({
                Title: this.appTextService.get(textId),
                Sref: FiStateNames.ChecklistV2.Template.List,
                SrefParams: { filterType: SideListOptionType.SharedWithMe },
                AddState: adminRight ? FiStateNames.ChecklistV2.Template.Add._name : null,
            });
        }

        if (this.stateAccessCheckService.isStateAllowedForCurrentUser(FiStateNames.ChecklistV2.Schedule.List)) {
            const textId = getObjectTypeNameTextId(ObjectTypes.ChecklistSchedule, true);
            tabs.push({
                Title: this.appTextService.get('checklist.manage_schedules', {
                    '{0}': this.appTextService.get(textId).toLowerCase(),
                }),
                Sref: FiStateNames.ChecklistV2.Schedule.List,
                SrefParams: { filterType: SideListOptionType.SharedWithMe },
                AddState: shareRight ? FiStateNames.ChecklistV2.Schedule.Add : null,
            });
        }

        if (this.stateAccessCheckService.isStateAllowedForCurrentUser(FiStateNames.ChecklistV2.Report.Dashboard)) {
            const textId = getObjectTypeNameTextId(ObjectTypes.Checklist2Report, true);
            tabs.push({
                Title: this.appTextService.get(textId),
                Sref: FiStateNames.ChecklistV2.Report.Dashboard,
                AddState: FiStateNames.ChecklistV2.Report.Dashboard,
            });
        }

        return tabs;
    }

    getChecklistV2AuditSettingsTabs() {
        const tabs: ITabItem[] = [];
        const adminRight = this.accessToApplicationTypeService.HasAccessToApplicationType(
            ApplicationSettingsType.ChecklistV2AuditLocal,
            AccessRightType.Admin,
        );
        const shareRight = this.accessToApplicationTypeService.HasAccessToApplicationType(
            ApplicationSettingsType.ChecklistV2AuditLocal,
            AccessRightType.Share,
        );

        if (this.stateAccessCheckService.isStateAllowedForCurrentUser(FiStateNames.ChecklistV2Audit.List)) {
            const textId = getObjectTypeNameTextId(ObjectTypes.Checklist2Audit, true);
            tabs.push({
                Title: this.appTextService.get(textId),
                Sref: FiStateNames.ChecklistV2Audit.List,
                SrefParams: { filterType: SideListOptionType.SharedWithMe },
                AddState: adminRight ? FiStateNames.ChecklistV2Audit.Add._name : null,
            });
        }

        if (this.stateAccessCheckService.isStateAllowedForCurrentUser(FiStateNames.ChecklistV2Audit.Template.List)) {
            const textId = getObjectTypeNameTextId(ObjectTypes.Checklist2AuditTemplate, true);
            tabs.push({
                Title: this.appTextService.get(textId),
                Sref: FiStateNames.ChecklistV2Audit.Template.List,
                SrefParams: { filterType: SideListOptionType.SharedWithMe },
                AddState: adminRight ? FiStateNames.ChecklistV2Audit.Template.Add._name : null,
            });
        }

        if (this.stateAccessCheckService.isStateAllowedForCurrentUser(FiStateNames.ChecklistV2Audit.Schedule.List)) {
            const textId = getObjectTypeNameTextId(ObjectTypes.Checklist2AuditSchedule, true);
            tabs.push({
                Title: this.appTextService.get('checklist.manage_schedules', {
                    '{0}': this.appTextService.get(textId).toLowerCase(),
                }),
                Sref: FiStateNames.ChecklistV2Audit.Schedule.List,
                SrefParams: { filterType: SideListOptionType.SharedWithMe },
                AddState: shareRight ? FiStateNames.ChecklistV2Audit.Schedule.Add : null,
            });
        }

        if (this.stateAccessCheckService.isStateAllowedForCurrentUser(FiStateNames.ChecklistV2Audit.Report.Dashboard)) {
            const textId = getObjectTypeNameTextId(ObjectTypes.Checklist2AuditReport, true);
            tabs.push({
                Title: this.appTextService.get(textId),
                Sref: FiStateNames.ChecklistV2Audit.Report.Dashboard,
                AddState: FiStateNames.ChecklistV2Audit.Report.Dashboard,
            });
        }

        return tabs;
    }
}
